import React from 'react';
import { ApiBessProvider } from '../api/ApiBess';

export const ApiProvider = ({ children }) => (
  <ApiBessProvider>
    {children}
  </ApiBessProvider>
);

